define('v3/Common/Bindings/SvgIcon.Binding',[
	'jquery',
	'knockout',
	'env'
], function ($, ko, env) {
	ko.bindingHandlers.svgIcon = {
		update: function (element, valueAccessor) {
			var link = ko.unwrap(valueAccessor());
			var xmlns = 'http://www.w3.org/2000/svg';
			var xlink = 'http://www.w3.org/1999/xlink';
			var use = document.createElementNS(xmlns, 'use');

			$(element).html(null).attr('class', ($(element).attr('class') || '') + (link ? ' icon-' + link.toLowerCase() : ''));

			use.setAttribute('xlink:href', env.paths.svgSprite + '#' + link);
			use.setAttributeNS(xlink, 'href', env.paths.svgSprite + '#' + link);
			element.appendChild(use);
		}
	};
});
